(() => {
  const setup = root => {
    if (root.dataset.qrReady) return;
    root.dataset.qrReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-qr-product]'));
    const grid = root.querySelector('[data-qr-grid]');
    const sort = root.querySelector('[data-qr-sort]');
    let category = 'all';
    function update() {
      let count = 0;
      const ordered = cards.map((card,index) => ({card,index}));
      if (sort.value === 'price-low') ordered.sort((a,b) => Number(a.card.dataset.price) - Number(b.card.dataset.price));
      if (sort.value === 'price-high') ordered.sort((a,b) => Number(b.card.dataset.price) - Number(a.card.dataset.price));
      ordered.forEach(({card}) => {
        card.hidden = category !== 'all' && !card.dataset.categories.trim().split(/\s+/).includes(category);
        if (!card.hidden) count++;
        grid.append(card);
      });
      root.querySelector('[data-qr-count]').textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
      root.querySelector('[data-qr-empty]').hidden = count !== 0;
      root.querySelectorAll('[data-qr-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.qrFilter === category)));
    }
    function filter(next) { category = next; update(); }
    root.querySelectorAll('[data-qr-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.qrFilter)));
    root.querySelectorAll('[data-qr-path-filter]').forEach(link => link.addEventListener('click', () => filter(link.dataset.qrPathFilter)));
    sort.addEventListener('change', update);
    const productDialog = root.querySelector('[data-qr-product-dialog]');
    const memorialDialog = root.querySelector('[data-qr-memorial-dialog]');
    const open = dialog => {
      if (typeof dialog.showModal !== 'function') return false;
      dialog.showModal(); return true;
    };
    root.querySelectorAll('[data-qr-quick-view]').forEach(button => button.addEventListener('click', () => {
      const card = button.closest('[data-qr-product]');
      const template = card.querySelector('[data-qr-detail-template]');
      const target = productDialog.querySelector('[data-qr-product-content]');
      target.replaceChildren(template.content.cloneNode(true));
      const variant = target.querySelector('[data-qr-variant]');
      if (variant) variant.addEventListener('change', () => { target.querySelector('[data-qr-variant-price]').textContent = variant.selectedOptions[0].dataset.price; });
      if (!open(productDialog)) window.location.assign(card.querySelector('a').href);
    }));
    root.querySelectorAll('[data-qr-open-memorial]').forEach(button => button.addEventListener('click', () => open(memorialDialog)));
    [productDialog, memorialDialog].forEach(dialog => {
      dialog.querySelector('[data-qr-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) { const box = dialog.getBoundingClientRect(); if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) dialog.close(); } });
    });
    const form = root.querySelector('[data-qr-brief-form]');
    form.addEventListener('input', () => { root.querySelector('[data-qr-brief-status]').textContent = ''; });
    form.addEventListener('submit', e => {
      e.preventDefault();
      const data = new FormData(form);
      const horse = String(data.get('horse') || '').trim();
      if (!horse) return;
      const text = `THE QUIET REIN\nMEMORIAL PILLOW DESIGN BRIEF\n\nHorse: ${horse}\nFabric direction: ${data.get('fabric')}\nBit: ${data.get('bit')}\n\nThe story behind the piece:\n${String(data.get('story') || '').trim() || 'To be shared in conversation.'}\n\nThis brief has not been sent. No order or payment has been placed. Design, availability, pricing, and timing need to be confirmed with The Quiet Rein.`;
      const href = URL.createObjectURL(new Blob([text], {type:'text/plain;charset=utf-8'}));
      const link = document.createElement('a'); link.href = href; link.download = 'Quiet-Rein-Memorial-Pillow-Brief.txt'; link.click();
      setTimeout(() => URL.revokeObjectURL(href), 1000);
      root.querySelector('[data-qr-brief-status]').textContent = `Your brief for ${horse} has been downloaded. It has not been sent.`;
    });
    update();
  };
  const init = scope => scope.querySelectorAll('[data-qr-home]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
